import * as React from 'react';
import {Container} from '../grid/container';
import './style.scss';
import {Translation} from "../../lang";

const hajzerImage = '/assets/src/components/founders/hajzer_bence.jpg';
const gaborJuhaszImage = '/assets/src/components/founders/gabor_juhasz.jpg';

/**
 * A megnyitott alapító kártyája kap 'open'-t, a másik 'close'-t.
 */
function toggleFounder(opened: string, closed: string) {
    document.querySelectorAll(`.founder.${opened}`).forEach((element: Element) => {
        element.classList.toggle('open');
        element.classList.remove('close');
    });

    document.querySelectorAll(`.founder.${closed}`).forEach((element: Element) => {
        element.classList.toggle('close');
        element.classList.remove('open');
    });
}

export class FoundersComponent extends React.Component<any, any> {
    render() {
        return <Container className="foundersComponent">
            <div className="container">
                <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                    <div
                        className="d-inline-block col-12 col-sm-12 col-md-10 col-lg-8 col-xl-10 MS text-white text-center content-height">

                        <h1 className="fw-bold fst-italic">{Translation.get('founders.title')}</h1>
                        <p className="fst-italic">{Translation.get('founders.description')}
                        </p>
                    </div>
                    <div
                        className="d-inline-block col-12 col-sm-12 col-md-10 col-lg-8 col-xl-10 MS text-white text-center content-height">
                        <div className="row justify-content-center">
                            {/*Desktop and tablet*/}
                            <div className="founders-desktop">
                                <div className="founder left" onClick={() => toggleFounder('left', 'right')}>
                                    <div className="image">
                                        <img src={hajzerImage} alt="Hajzer Bence"/>
                                        <div className="text">
                                            <span className="name">{Translation.get('founders.bence.title')}</span>
                                            <span className="title">COO</span>
                                        </div>
                                    </div>
                                    <p className="description">{Translation.get('founders.bence.description')}</p>

                                </div>
                                <div className="founder right" onClick={() => toggleFounder('right', 'left')}>
                                    <div className="image">
                                        <img src={gaborJuhaszImage} alt="Juhász Gábor"/>
                                        <div className="text">
                                            <span className="name">{Translation.get('founders.gabor.title')}</span>
                                            <span className="title">CTO</span>
                                        </div>
                                    </div>
                                    <p className="description">{Translation.get('founders.gabor.description')}</p>
                                </div>
                            </div>
                            {/*Mobile*/}
                            <div className="founders-mobile">
                                <div className="founder">
                                    <div className="image">
                                        <img src={gaborJuhaszImage} alt=""/>
                                    </div>
                                    <div className="text">
                                        <span className="name">Juhász Gábor</span>
                                        <span className="title">CTO</span>
                                    </div>
                                    <p className="description"></p>
                                </div>
                                <div className="founder">
                                    <div className="image">
                                        <img src={hajzerImage} alt=""/>
                                    </div>
                                    <div className="text">
                                        <span className="name">Hajzer Bence</span>
                                        <span className="title">COO</span>
                                    </div>
                                    <p className="description">Munkám a cég operatív feladatainak menedzselése, de
                                        valójában alkotni, optimalizálni szeretek. Kitalálni, új lehetőségeket
                                        kipróbálni, több lehetőséget végig gondolva a lehető legjobb
                                        döntést hozni, ez az ami minden reggel izgalommal tölt el! Azt csinálhatom amit
                                        a legjobban szeretek, úgy érzem, hogy versenyző de ugyanakkor csapatjátékos
                                        típusként is a legjobb helyen vagyok!</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>;
    }
}
